module.exports = __webpack_public_path__ + "img/img5.70eb7967.png";